var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewState } from '../../state/view.state';
import { takeUntil } from 'rxjs/operators';
var ViewContentModeComponent = /** @class */ (function () {
    // ---------- Lifecyle Events ----------
    function ViewContentModeComponent(store, viewService, layoutService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
        // ---------- Input / Output ----------
        this.layout = 'column';
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
    }
    ViewContentModeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store
            .select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.changeDetectorRef.markForCheck();
        });
    };
    ViewContentModeComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Layout ----------
    ViewContentModeComponent.prototype.isVisible = function (layout) {
        return this.layoutService.isLayoutVisible(layout);
    };
    ViewContentModeComponent.prototype.isEnabled = function (layout) {
        return this.layoutService.isLayoutEnabled(layout);
    };
    // ---------- Interaction ----------
    ViewContentModeComponent.prototype.handlePrevClick = function () {
        this.selectLabel(-1);
    };
    ViewContentModeComponent.prototype.handleNextClick = function () {
        this.selectLabel(1);
    };
    ViewContentModeComponent.prototype.selectLabel = function (increment) {
        var labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
        var labelCount = labels.length;
        var selectedLabelId = this.store.selectSnapshot(StoryLabelsState.getSelectedLabelId);
        var selectedLabelIndex = labels.findIndex(function (label) { return label.id === selectedLabelId; });
        // get next index
        var nextIndex = selectedLabelIndex !== -1
            // increment
            ? selectedLabelIndex + increment
            // defafult
            : 0;
        // cycle target index in range
        var targetLabelIndex = (nextIndex % labelCount + labelCount) % labelCount;
        // get target label
        var targetLabel = labels[targetLabelIndex];
        if (targetLabel) {
            this.viewService.selectLabel(targetLabel, true);
        }
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewContentModeComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryLabelsState.getChapterLabels),
        __metadata("design:type", Observable)
    ], ViewContentModeComponent.prototype, "labels$", void 0);
    return ViewContentModeComponent;
}());
export { ViewContentModeComponent };
